import { createSlice } from '@reduxjs/toolkit';

const donationFormSlice = createSlice({
  name: 'donationForm',
  initialState: {
    savedFormState: null, // Stores form data when navigating to add contact
  },
  reducers: {
    saveDonationFormState: (state, action) => {
      state.savedFormState = action.payload;
    },
    clearDonationFormState: (state) => {
      state.savedFormState = null;
    },
  },
});

export const { saveDonationFormState, clearDonationFormState } = donationFormSlice.actions;

// Selectors
export const selectSavedDonationFormState = (state) => state.donationForm.savedFormState;

export default donationFormSlice.reducer;
